import { Box, Container, Grid, Button, Typography, Paper, Chip } from "@mui/material";
import { Budget } from "../../components/dashboard/budget";
import { Sales } from "../../components/dashboard/sales";
import { TasksProgress } from "../../components/dashboard/tasks-progress";
import { TotalCustomers } from "../../components/dashboard/total-customers";
import { TotalProfit } from "../../components/dashboard/total-profit";
import { TrafficByDevice } from "../../components/dashboard/traffic-by-device";
import { DashboardLayoutCustomer } from "../../components/dashboard-layout-customer";
import { ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom"; // Đã bỏ useSearchParams
import { theme } from "../../theme";
import { useEffect, useState } from "react";
import axios from "axios";

// Component phụ trợ để vẽ từng Thẻ sao chép cho đẹp
const CopyCard = ({ title, value, onCopy, icon }) => (
    <Box sx={{
        p: 3,
        bgcolor: '#ffffff',
        borderRadius: 3,
        border: '1px solid #E2E8F0',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        height: '100%',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
            boxShadow: '0 12px 24px -10px rgba(0,0,0,0.1)',
            borderColor: '#CBD5E1',
            transform: 'translateY(-2px)'
        }
    }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: 0.5, display: 'flex', alignItems: 'center', gap: 1 }}>
            {icon} {title}
        </Typography>
        
        <Box sx={{ 
            flexGrow: 1, 
            display: 'flex', 
            alignItems: 'center',
            p: 2, 
            bgcolor: '#F8FAFC', 
            borderRadius: 2,
            border: '1px dashed #CBD5E1'
        }}>
            <Typography variant="body1" sx={{ fontWeight: 600, color: '#0F172A', wordBreak: 'break-all' }}>
                {value || "Đang tải dữ liệu..."}
            </Typography>
        </Box>

        <Button 
            variant="contained" 
            disableElevation
            onClick={() => onCopy(value)}
            disabled={!value}
            sx={{ 
                py: 1.2,
                borderRadius: 2,
                fontWeight: 600,
                textTransform: 'none',
                bgcolor: '#0F172A',
                '&:hover': { bgcolor: '#334155' }
            }}
        >
            Sao chép
        </Button>
    </Box>
);

function Dashboard() {
    const navigate = useNavigate();
    
    // State lưu tên miền, mặc định là kimsa88.net
    const [baseDomain, setBaseDomain] = useState("kimsa88.net");

    const [data, setData] = useState();
    const [profile, setProfile] = useState(null);

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const [employee, setEmployee] = useState();
    const [users, setUsers] = useState(null);
    const [content, setContent] = useState(null);
    const [users2, setUsers2] = useState(false);
    const [nap, setNap] = useState(false);
    const [rut, setRut] = useState(false);
    const [cuoc, setCuoc] = useState(false);
    
    // Đọc file config.json để lấy tên miền dùng chung cho tất cả
    useEffect(() => {
        // Thêm ?v=... để chống trình duyệt lưu cache, đảm bảo lấy đúng domain mới nhất
        fetch(`/config.json?v=${new Date().getTime()}`)
            .then((res) => res.json())
            .then((configData) => {
                if (configData && configData.DOMAIN) {
                    setBaseDomain(configData.DOMAIN);
                }
            })
            .catch((err) => console.log("Không tìm thấy cấu hình tên miền, dùng mặc định."));
    }, []);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/statistic/getallcustomer`).then((res) => setData(res.data.data));
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`).then((res) => {
            if (res.data && res.data.success) {
                setProfile(res.data.data);
            }
        });
    }, []);

    const referralCode = profile ? profile.code : "";
    const linkMobile = referralCode ? `https://m.${baseDomain}/register?ref=${referralCode}` : "";
    const linkPC = referralCode ? `https://${baseDomain}/register?ref=${referralCode}` : "";

    const handleCopy = (text) => {
        if (text) {
            navigator.clipboard.writeText(text);
            alert("Đã sao chép thành công!");
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayoutCustomer>
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        py: 4,
                        backgroundColor: '#F1F5F9',
                        minHeight: '100vh'
                    }}>
                    <Container maxWidth="xl">
                        <Grid container spacing={4}>
                            
                            {/* --- KHU VỰC MÃ GIỚI THIỆU --- */}
                            <Grid item xs={12}>
                                <Paper sx={{ 
                                    p: { xs: 3, md: 5 }, 
                                    borderRadius: 4, 
                                    border: "none", 
                                    boxShadow: "0px 10px 30px rgba(0,0,0,0.03)",
                                    background: "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <Box sx={{
                                        position: 'absolute', top: -50, right: -50, width: 200, height: 200,
                                        borderRadius: '50%', background: 'linear-gradient(145deg, #E2E8F0 0%, #F1F5F9 100%)', opacity: 0.5
                                    }}/>

                                    <Box sx={{ mb: 4, position: 'relative', zIndex: 1 }}>
                                        <Typography variant="h4" sx={{ fontWeight: 800, color: '#0F172A', mb: 1, letterSpacing: -0.5 }}>
                                            🚀 Cổng Giới Thiệu Đối Tác
                                        </Typography>
                                        <Typography variant="body1" sx={{ color: '#64748B', maxWidth: '600px', lineHeight: 1.6 }}>
                                            Chia sẻ mã hoặc liên kết dưới đây để mời bạn bè tham gia. Bạn sẽ nhận được hoa hồng tự động khi họ đăng ký thành công.
                                        </Typography>
                                        <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Typography variant="body2" sx={{ fontWeight: 600, color: '#475569' }}>
                                                Tên miền đang sử dụng:
                                            </Typography>
                                            <Chip label={baseDomain} color="primary" size="small" sx={{ fontWeight: 'bold', borderRadius: 2 }} />
                                        </Box>
                                    </Box>

                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={4}>
                                            <CopyCard 
                                                title="Mã Giới Thiệu" 
                                                value={referralCode} 
                                                onCopy={handleCopy} 
                                                icon="🏷️️" 
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <CopyCard 
                                                title="Liên Kết Đăng Ký (PC)" 
                                                value={linkPC} 
                                                onCopy={handleCopy} 
                                                icon="💻" 
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <CopyCard 
                                                title="Liên Kết Đăng Ký (Mobile)" 
                                                value={linkMobile} 
                                                onCopy={handleCopy} 
                                                icon="📱" 
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            {/* --- KHU VỰC 4 THẺ THỐNG KÊ --- */}
                            <Grid item xl={3} lg={3} sm={6} xs={12}>
                                {data && <TotalCustomers user={data.thanhvien} />}
                            </Grid>
                            <Grid item xl={3} lg={3} sm={6} xs={12}>
                                {data && <Budget tongnap={data.tongnaps} />}
                            </Grid>
                            <Grid item xl={3} lg={3} sm={6} xs={12}>
                                {data && <TasksProgress tongrut={data.tongruts} />}
                            </Grid>
                            <Grid item xl={3} lg={3} sm={6} xs={12}>
                                {data && <TotalProfit tongcuoc={data.tongcuoc} sx={{ height: "100%" }} />}
                            </Grid>

                            {/* --- KHU VỰC BIỂU ĐỒ --- */}
                            <Grid item lg={8} md={12} xl={8} xs={12}>
                                <Box sx={{ 
                                    height: '100%', 
                                    borderRadius: 4, 
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.03)', 
                                    bgcolor: 'white',
                                    overflow: 'hidden'
                                }}>
                                    <Sales sx={{ border: "none" }} data={data} />
                                </Box>
                            </Grid>
                            <Grid item lg={4} md={12} xl={4} xs={12}>
                                <Box sx={{ 
                                    height: '100%', 
                                    borderRadius: 4, 
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.03)', 
                                    bgcolor: 'white',
                                    overflow: 'hidden'
                                }}>
                                    <TrafficByDevice sx={{ border: "none", height: "100%" }} data={data} />
                                </Box>
                            </Grid>

                        </Grid>
                    </Container>
                </Box>
            </DashboardLayoutCustomer>
        </ThemeProvider>
    );
}

export default Dashboard;